import React from 'react'

import { Box } from 'widgets/Box'
import { Modal } from 'widgets/Modal'
import { Text } from 'widgets/Text'

interface Props {
  handleClose: () => void
  handleDiscard: () => void
  isVisible: boolean
}

export const DiscardChangesModal = ({
  handleClose,
  handleDiscard,
  isVisible,
}: Props): JSX.Element => (
  <Modal
    actionButtonProps={[
      {
        title: 'Continue',
        onPress: handleClose,
        type: 'grey',
      },
      {
        title: 'Discard',
        onPress: handleDiscard,
        type: 'v2primary',
      },
    ]}
    onClose={handleClose}
    isVisible={isVisible}
    title='Discard changes?'
  >
    <Box align='center'>
      <Text fontSize='sm' align='center'>
        Are you sure you wish to discard changes and leave this post?
      </Text>
    </Box>
  </Modal>
)
